import { Component } from '@angular/core';
import { GroupPageBase } from './group-page.base';

/** A map's group: everyone with access to the map. */
@Component({
  selector: 'app-social-group',
  templateUrl: './social-group.component.html',
  styleUrls: ['./social-group.component.scss'],
  standalone: false,
})
export class SocialGroupComponent extends GroupPageBase {
  readonly kind: 'map' | 'game' = 'map';
  protected routeParam = 'groupId';

  protected fetchGroup(id: number) {
    return this.social.getGroup(id);
  }

  protected fetchPosts(id: number, page: number) {
    return this.social.getFeed({ group: id, page });
  }

  protected fetchMembers(id: number) {
    return this.social.getGroupMembers(id);
  }
}
